import { render, staticRenderFns } from "./ShopAssetEditor.vue?vue&type=template&id=0daddaa3&scoped=true&"
import script from "./ShopAssetEditor.vue?vue&type=script&lang=js&"
export * from "./ShopAssetEditor.vue?vue&type=script&lang=js&"
import style0 from "./ShopAssetEditor.vue?vue&type=style&index=0&id=0daddaa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daddaa3",
  null
  
)

export default component.exports